<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <!-- Tab general -->
                                    <CTab :title="$t('General')">
                                        <CContainer class="mt-4">
                                            <CRow class="mb-3">
                                                <CCol sm="12">
                                                    <h5>
                                                        {{
                                                            $t(
                                                                "create_your_api_integration"
                                                            )
                                                        }}
                                                    </h5>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol md="9" sm="12">
                                                    <CInput
                                                        :isValid="
                                                            checkIfFormValid({
                                                                form_name:
                                                                    'integration',
                                                                field_name:
                                                                    'name',
                                                            })
                                                        "
                                                        :value.sync="
                                                            $v.forms.integration
                                                                .name.$model
                                                        "
                                                        :label="$t('name')"
                                                        :placeholder="
                                                            $t('enter_the_name')
                                                        "
                                                        :invalidFeedback="
                                                            $t(
                                                                'name_is_required'
                                                            )
                                                        "
                                                        :horizontal="
                                                            default_horizontal
                                                        "
                                                        size="sm"
                                                    />
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol>
                                                    <h5>
                                                        {{
                                                            $t("apis_available")
                                                        }}
                                                    </h5>
                                                    <p class="mb-0">
                                                        {{
                                                            $t(
                                                                "you_can_select_one_of_the_available_apis_to_integrate"
                                                            )
                                                        }}
                                                    </p>
                                                </CCol>
                                            </CRow>
                                            <CRow class="mt-3">
                                                <CCol>
                                                    <CSelect
                                                        :options="
                                                            pluginsAsOptions
                                                        "
                                                        :value.sync="
                                                            forms.integration
                                                                .driver_id
                                                        "
                                                        :disabled="
                                                            routeName.includes(
                                                                'edit'
                                                            )
                                                        "
                                                        :placeholder="
                                                            $t(
                                                                'select_an_api_integration'
                                                            )
                                                        "
                                                        size="sm"
                                                    >
                                                    </CSelect>

                                                    <p
                                                        v-if="
                                                            forms.integration
                                                                .driver_id
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                plugin.description
                                                            )
                                                        }}
                                                    </p>
                                                </CCol>
                                                <CCol md="2">
                                                    <CImg
                                                        v-if="
                                                            forms.integration
                                                                .driver_id
                                                        "
                                                        :src="plugin.logo"
                                                        class="img_plugin"
                                                    />
                                                </CCol>
                                            </CRow>
                                            <CRow v-if="plugin">
                                                <CCol>
                                                    <h5>
                                                        {{ $t("credentials") }}
                                                    </h5>
                                                    <p>
                                                        {{
                                                            $t(
                                                                "set_your_api_credentials_for_this_integration"
                                                            )
                                                        }}.
                                                    </p>
                                                </CCol>
                                            </CRow>
                                            <CRow v-if="plugin">
                                                <CCol
                                                    v-if="
                                                        plugin.uuid ==
                                                        $options.consts
                                                            .SFTP_PLUGIN_ID
                                                    "
                                                >
                                                    <CCSftpCredentials
                                                        :value.sync="
                                                            forms.integration
                                                                .credentials
                                                        "
                                                    >
                                                    </CCSftpCredentials>
                                                </CCol>
                                                <CCol v-else>
                                                    <template
                                                        v-for="(
                                                            item, index
                                                        ) in plugin.credentials"
                                                    >
                                                        <CInput
                                                            v-if="!item.hidden"
                                                            :key="index"
                                                            :value.sync="
                                                                forms
                                                                    .integration
                                                                    .credentials[
                                                                    item
                                                                ]
                                                            "
                                                            :placeholder="item"
                                                            :label="item"
                                                        />
                                                    </template>
                                                </CCol>
                                            </CRow>
                                            <CRow
                                                v-if="
                                                    forms.integration
                                                        .driver_id ==
                                                    '15550f37-7d19-40fd-98cb-f59353f6687e'
                                                "
                                            >
                                                <CCol>
                                                    <CButton
                                                        class="button btnFacebook"
                                                        @click="myFbLogin"
                                                    >
                                                        <span
                                                            class="button__icon"
                                                        >
                                                            <CIcon
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cibFacebookF
                                                                "
                                                            />
                                                        </span>
                                                        <span
                                                            class="button__text"
                                                        >
                                                            {{
                                                                $t(
                                                                    "Login With Facebook"
                                                                )
                                                            }}
                                                        </span>
                                                    </CButton>
                                                    <p
                                                        v-if="
                                                            forms.integration
                                                                .credentials[
                                                                'pages_token'
                                                            ]
                                                        "
                                                        class="colorFacebook mt-3"
                                                    >
                                                        <strong>
                                                            {{
                                                                $t(
                                                                    "We have successfully connected with Facebook."
                                                                )
                                                            }}
                                                        </strong>
                                                    </p>
                                                </CCol>
                                            </CRow>
                                        </CContainer>
                                    </CTab>
                                    <CTab
                                        :title="$t('Configuration')"
                                        :disabled="!plugin"
                                    >
                                        <CContainer class="mt-4" v-if="plugin">
                                            <CRow class="mb-3">
                                                <CCol sm="12">
                                                    <h5>
                                                        {{
                                                            $t(
                                                                "Set integration configuration."
                                                            )
                                                        }}
                                                    </h5>
                                                </CCol>
                                            </CRow>

                                            <CRow
                                                class="mb-3"
                                                v-if="
                                                    plugin &&
                                                    plugin.uuid ==
                                                        $options.consts
                                                            .HTTP_PLUGIN_ID
                                                "
                                            >
                                                <CCol sm="12">
                                                    <CCMethodApiConfiguration
                                                        id="http-pluging-configuration"
                                                        :value.sync="
                                                            forms.integration
                                                                .configuration
                                                        "
                                                        :encode="true"
                                                    >
                                                    </CCMethodApiConfiguration>
                                                </CCol>
                                            </CRow>
                                            <CRow
                                                class="mb-3"
                                                v-if="
                                                    plugin &&
                                                    plugin.uuid ==
                                                        $options.consts
                                                            .SFTP_PLUGIN_ID
                                                "
                                            >
                                                <CCol sm="12">
                                                    <CCSftpConfiguration
                                                        id="sftp-pluging-configuration"
                                                        :value.sync="
                                                            forms.integration
                                                                .configuration
                                                        "
                                                        :encode="true"
                                                    >
                                                    </CCSftpConfiguration>
                                                </CCol>
                                            </CRow>
                                            <CRow v-else>
                                                <CCol>
                                                    <CAlert color="warning">
                                                        {{
                                                            $t(
                                                                "This plugin not required configuration"
                                                            )
                                                        }}
                                                    </CAlert>
                                                </CCol>
                                            </CRow>
                                        </CContainer>
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <!-- Button send -->
                                <ButtonSave color="success" @click="save()" />
                                <!-- Button back -->
                                <ButtonBack class="mr-3" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import ButtonBack from "£lement/ButtonBack";
import ButtonSave from "~/components/ButtonSave.vue";
import CCMethodApiConfiguration from "~/components/CCMethodApiConfiguration.vue";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";

/**
 * Others
 */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilCaretBottom,
    cibFacebookF,
} from "@coreui/icons";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { CContainer } from "@coreui/vue";
import { HTTP_PLUGIN_ID, SFTP_PLUGIN_ID } from "./config/consts";
import CCSftpCredentials from "./Components/CCSftpCredentials.vue";
import CCSftpConfiguration from "./Components/CCSftpConfiguration.vue";

export default {
    name: "IntegrationConfigPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin],
    components: {
        ButtonBack,
        ButtonSave,
        CCMethodApiConfiguration,
        CCSftpConfiguration,
        CCSftpCredentials,

    },
    consts: {
        HTTP_PLUGIN_ID,
        SFTP_PLUGIN_ID,
    },
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilCaretBottom,
        cibFacebookF,
    },
    data() {
        return {
            forms: {
                integration: {
                    name: null,
                    status: true,
                    driver_id: null,
                    credentials: null,
                    configuration: null,
                },
            },
            tables: {
                lists: {
                    fields: [
                        {
                            key: "id",
                            label: this.$t("id"),
                        },
                        {
                            key: "list_name",
                            label: this.$t("name"),
                        },
                        {
                            key: "list",
                            label: this.$t("list"),
                        },
                    ],
                    items: [],
                },
            },
            plugins: [],
            test: this.$t("test"),
            selectedList: null,
        };
    },
    watch: {
        plugin(newValue, oldValue) {
            if (!this.forms.integration.credentials) {
                this.forms.integration.credentials = {};
                for (let i = 0; i < newValue.credentials.length; i++) {
                    const element = newValue.credentials[i];
                    if (!element.hidden) {
                        this.forms.integration.credentials = {
                            ...this.forms.integration.credentials,
                            [element]: null,
                        };
                    }
                }
            }
        },
    },

    validations: {
        forms: {
            integration: {
                name: {
                    required,
                },
                status: {},
                driver_id: {
                    required,
                },
            },
        },
    },
    computed: {
        ...mapGetters({
            storePlugins: "global/plugins",
        }),
        uuid: function () {
            return this.$route.query.uuid;
        },
        routeName() {
            return this.$route.name;
        },
        plugin() {
            return this.storePlugins.find(
                (plugin) => plugin.uuid == this.forms.integration.driver_id
            );
        },
        pluginsAsOptions() {
            return this.storePlugins.map((plugin) => {
                return {
                    value: plugin.uuid,
                    label: plugin.name,
                };
            });
        },
    },
    methods: {
        formatPluginOptions(data) {
            return data.items.map((option) => {
                return {
                    value: option.uuid,
                    text: option.name,
                };
            });
        },

        formParseData({ data }) {
            let parseData = {
                ...data._items,
            };
            parseData.credentials = JSON.parse(parseData.credentials);
            return parseData;
        },

        async updateForm({ formName, url }) {
            let data = await this.loadData({
                url,
            });

            if (this.formParseData) {
                data = await this.formParseData({
                    data,
                });
            }

            await this.loadForm({
                form_name: formName,
                data,
            });
        },

        async loadPlugins() {
            if (this.storePlugins.length == 0) {
                let plugins = await this.fetcher({
                    url: "/connector.api/plugins",
                });

                this.$store.dispatch("global/savePlugins", {
                    plugins: plugins._items,
                });
            }
        },

        selectPlugin(plugin) {
            this.forms.integration.driver_id = plugin.uuid;
        },
        formatOptions(data) {
            return data._items.map((item) => {
                return {
                    text: item.name,
                    value: item.id,
                };
            });
        },

        async onChangeSelectList(data) {
            try {
                if (data) {
                    let dataResp = await this.fetcher({
                        url: "/connector.api/postPluginConfigurationAssocList",
                        method: "POST",
                        data: {
                            configId: this.uuid,
                            listId: data.value,
                            listName: data.text,
                        },
                    });
                    this.updateTableAssocLists();
                }
            } catch (e) {
                this.showMessageError(e);
            } finally {
                this.selectedList = null;
            }
        },
        async updateTableAssocLists() {
            await this.updateTable({
                table_name: "lists",
                url: `/connector.api/getPluginConfigurationAssocLists/${this.uuid}`,
                filter_active: false,
            });
        },

        async save() {
            try {
                await this.sendForm({
                    form_name: "integration",
                    url: "/connector.api/pluginCredentials",
                    url_param: this.uuid,
                });
                this.$router.go(-1);
            } catch (error) {
                console.log(error);
            }
        },

        async myFbLogin() {
            const REDIRECT_URI = encodeURIComponent(
                window.location.origin + "/app/integrations/facebook/callback"
            );

            const buildUrlCode = () => {
                let STATE = "fbloged=1";
                let FB_ID = process.env.VUE_APP_FACEBOOK_ID;
                let CONFIG_ID = process.env.VUE_APP_FACEBOOK_CONFIG;
                let REPSONSE_TYPE = "code";
                return `https://www.facebook.com/v20.0/dialog/oauth?client_id=${FB_ID}&config_id=${CONFIG_ID}&response_type=${REPSONSE_TYPE}&redirect_uri=${REDIRECT_URI}&state=${STATE}`;
            };

            const popupLogin = (url, windowName, win, w, h) => {
                const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
                const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
                return win.open(
                    url,
                    windowName,
                    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`
                );
            };

            const getCode = async () => {
                return new Promise((resolve, reject) => {
                    let popup = popupLogin(
                        buildUrlCode(),
                        "",
                        window,
                        500,
                        500
                    );
                    var eventMethod = window.addEventListener
                        ? "addEventListener"
                        : "attachEvent";
                    var eventer = window[eventMethod];
                    var messageEvent =
                        eventMethod == "attachEvent" ? "onmessage" : "message";

                    eventer(
                        messageEvent,
                        function (e) {
                            if (e.origin != window.location.origin) {
                                reject(e);
                            }

                            resolve(e.data.code ? e.data.code : "");
                            popup.close();
                        },
                        false
                    );
                });
            };

            try {
                let code = await getCode();
                let dataResp = await this.fetcher({
                    url:
                        "/connector.api/plugins/" +
                        this.forms.integration.driver_id +
                        "/actions/cf29a00e-c0f5-43e4-8e4d-94777c39241c/execute",
                    method: "POST",
                    data: {
                        code: code,
                        redirectUri: REDIRECT_URI,
                    },
                });
                this.forms.integration.credentials = {
                    ["pages_token"]: dataResp.pluginActionResponse,
                };
            } catch (e) {
                this.showMessageError(e);
            }
        },
    },
    async mounted() {},
    async created() {
        await this.loadPlugins();
        if (this.routeName.includes("edit")) {
            await this.updateForm({
                formName: "integration",
                url: "/connector.api/integrations/" + this.uuid,
            });
            await this.updateTableAssocLists();
        }

        this.$store.dispatch("page/updateLoading", {
            loading: false,
        });
    },
};
</script>
<style lang="scss" scoped>
.plugin {
    & .img_plugin {
        height: 7em;
        width: auto;
    }
}
.btnFacebook {
    color: white;
    background-color: #23599b !important;
}
.colorFacebook {
    color: #23599b !important;
}
</style>
